import { CenterAlignedLoader } from '@medly-components/core';
import { HTMLProps, useEffect, useState } from 'react';

type useImage = {
    url: string;
    defaultImage: string;
    imageProps: Partial<HTMLProps<HTMLImageElement>> & {
        crossOrigin?: '' | 'anonymous' | 'use-credentials';
        testid: string;
    };
};
export const useImage = ({ url, defaultImage, imageProps: { testid, ...props } }: useImage) => {
    const [isValid, setIsValid] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const checkImageValidity = (url: string) => {
        const img = new Image();
        img.src = url;

        img.onload = () => {
            setIsValid(true);
            setIsLoading(false);
        };

        img.onerror = () => {
            setIsValid(false);
            setIsLoading(false);
        };
    };

    useEffect(() => {
        checkImageValidity(url);
    }, [url]);

    if (isLoading) {
        return <CenterAlignedLoader data-testid={testid} />;
    }

    return <img {...props} src={isValid ? url : defaultImage} data-testid={testid}></img>;
};
